module.exports = __webpack_public_path__ + "a807dd12b0b34bd1fba48fbef3df211a.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/4_column_medium_x1_variable/public/picture/Stanley.jpg
// module id = 417
// module chunks = 0